import { getMe, logout as apiLogout } from './api'

export function setAuthToken(token) {
  localStorage.setItem('fw_token', token)
}

export function getAuthToken() {
  return localStorage.getItem('fw_token')
}

export function removeAuthToken() {
  localStorage.removeItem('fw_token')
}

export async function checkAuth() {
  try {
    const user = await getMe()
    return user
  } catch {
    return null
  }
}

export async function logout() {
  removeAuthToken()
  await apiLogout()
  window.location.href = '/'
}
